import React from 'react';
import { Box } from '@mui/material';
import useTheme from '../Layout/useTheme';

export default function EmailLink({ email, children }) {
  const [user, domain] = email.split('@');
  const theme = useTheme();
  const color = theme.palette.primary.main;

  return (
    <Box
      component="button"
      sx={{
        color: 'primary.main',
        fontFamily: 'fontFamily',
        background: 'none!important',
        border: 'none',
        padding: '0!important',
        cursor: 'pointer',
        textDecoration: 'underline',
        textDecorationColor: `color-mix(in srgb, ${color}, transparent 60%)`,
        fontSize: 'inherit',
        '&:hover': {
          textDecoration: 'none',
        },
      }}
      onClick={() => {
        window.location.href = 'mailto:' + user + '@' + domain;
      }}
    >
      {children}
    </Box>
  );
}
